var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user flex main other_main"},[_c('asiden',{attrs:{"asideData":_vm.asideList}}),_c('div',{staticClass:"main_r"},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }